import './ui/confirm';
import './modules/admin';
import 'bootstrap';


// Assets
// These assets are extracted to [id].bundle.css using MiniCssExtractPlugin, see more on webpack.config.js
import "bootstrap/scss/bootstrap.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import './theme/customAdmin.scss';

import * as editor from './ui/editor';

editor.render();
 
// Webpack HMR
if (module.hot) {
	module.hot.accept();;
  }